import { useMutation } from '@tanstack/react-query'
import { toast } from '@/integrations/toaster-provider'
import { donationsApi } from '../api/donationsApi'
import { useDonationsStore } from '../store/donationsStore'
import type { ApiError } from '@/types/api'
import { notifyRequestError } from '@/utils/notifyRequestError'

export const useSendRegistrationRequestMutation = () => {
  const update = useDonationsStore((s) => s.update)

  return useMutation({
    mutationFn: (donationId: string) =>
      donationsApi.sendRegistrationRequest(donationId).then((r) => r.data),
    onSuccess: (data) => {
      update(data.donation)
      toast.success(`Registration email sent to ${data.sentTo}`)
    },
    onError: (error: ApiError) => {
      notifyRequestError(error, 'Failed to send registration request email.')
    },
  })
}
